module.exports = __webpack_public_path__ + "img/thank-img-hover.97a73877.png";